export interface SnapshotsConfigurationsBackupResponse {
  data: SnapshotsConfigurationsBackupResponseContent[];
}

export interface SnapshotsConfigurationsBackupResponseContent {
  key: string;
  interval: string;
}

export interface Vdd {
  key: string;
  logicalLink: string;
}

export interface VddsByLogicalLink {
  logicalLinkName: string;
  vddNames: string[];
}

export interface Snapshot {
  createdAt: string;
  createdBy: string;
  editedAt: string;
  id: string;
  status: SnapshotUploadStatus;
  statusChangedAt: string;
}

export enum SnapshotUploadStatus {
  RUNNING = 'running',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
  FAILED = 'failed',
  UPLOADED = 'uploaded',
}

export interface SnapshotsResponse {
  data: Snapshot[];
}

export interface CreateSnapshotResponse {
  data: Snapshot;
}

export interface VddWithContent {
  key: string;
  structure: any;
  values: any;
  logicalLink: string;
}

export interface SnapshotVddsResponse {
  data: VddWithContent[];
}

export interface SnapshotResponse {
  data: { status: SnapshotUploadStatus };
}
